import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Sprout — the 🌱 emoji rendered as a proper accessible component.
 * Sizes slightly smaller than its paired heading for optical balance.
 *
 * @param {string} size - Trellis tier: 'display-lg' | 'display-md' | 'heading-lg' | 'nav' (default)
 */
export function Sprout({ size }) {
  const sizes = {
    'display-lg': '56px',
    'display-md': '36px',
    'heading-lg': '28px',
    'nav': '20px',
  };

  return (
    <span
      role="img"
      aria-label="sprout"
      style={{
        fontSize: sizes[size] || '0.875em',
        display: 'inline-block',
        verticalAlign: 'baseline',
        lineHeight: 1,
        transform: 'translateY(-0.05em)',
      }}
    >🌱</span>
  );
}

/**
 * CompanyMark — the Watering Can logo used site-wide.
 * Renders: 🌱 Watering Can
 *
 * @param {string} className - pass-through class
 * @param {object} style - pass-through styles (merged with built-in)
 * @param {function} onClick - pass-through click handler
 * @param {string} to - Link destination (default "/"). Pass null to render as span.
 */
const CompanyMark = React.forwardRef(function CompanyMark({ className, style, onClick, to = '/' }, ref) {
  const baseStyle = {
    fontFamily: "'Averia Serif Libre', serif",
    fontSize: '24px',
    fontWeight: 700,
    color: '#374151',
    textDecoration: 'none',
    letterSpacing: '-0.055em',
    ...style,
  };

  const content = (
    <>
      <Sprout size="nav" />{'\u00A0'}Watering Can
    </>
  );

  if (to === null) {
    return (
      <span ref={ref} className={className} style={baseStyle} onClick={onClick}>
        {content}
      </span>
    );
  }

  return (
    <Link ref={ref} to={to} className={className} style={baseStyle} onClick={onClick}>
      {content}
    </Link>
  );
});

export default CompanyMark;
